import { Collapse } from "antd";
import { useApiData } from "../../context/ApiDataContext";
import "./style.scss";

const FAQ = () => {
  const { faq } = useApiData();

  return (
    <div className={`faq`}>
      <Collapse
        accordion
        size="large"
        bordered={false}
        items={faq}
        defaultActiveKey={["1"]}
        expandIconPosition="end"
      />
    </div>
  );
};

export default FAQ;
